<template>
  <div>
    <head-nav-bar
      :title="restaruantInfo ? restaruantInfo.CompanyName + ' - 订餐' : '订餐'"
      :fixed="true"
      :left-arrow="false"
    />
    <div class="mt-header-nav">
      <van-swipe
        :autoplay="3000"
        class="swipe-wrap"
        :class="{ 'no-pic': !images.length }"
      >
        <van-swipe-item
          v-for="(image, index) in images"
          :key="index"
          @click="preview"
        >
          <img v-lazy="image" />
        </van-swipe-item>
      </van-swipe>
      <van-cell-group class="booking-form">
        <van-cell>
          <span style="color:#00af54"
            ><van-icon name="volume-o" /> 欢迎进入点餐系统！</span
          >
        </van-cell>
        <van-field
          v-model="form.Contact"
          label="联系人"
          required
          clearable
          placeholder="联系人"
        />
        <van-field
          v-model="form.Phone"
          type="tel"
          label="电话"
          required
          clearable
          placeholder="电话"
        />
        <van-field
          v-model="form.PersonCount"
          type="digit"
          required
          clearable
          label="就餐人数"
        />
        <van-field
          v-model="form.CheckInTime"
          readonly
          required
          clearable
          label="用餐时间"
          placeholder="点击此处选择时间"
          @click="showSelectDate"
        />
        <van-field
          v-model="form.OrderRemark"
          rows="5"
          autosize
          label="备注"
          clearable
          type="textarea"
          placeholder="备注"
        />
      </van-cell-group>
      <van-goods-action style="bottom:5px">
        <van-goods-action-button
          color="#f80"
          text="我的订单"
          @click="$router.push({ name: 'restaurantBookingList' })"
        />
        <van-goods-action-button
          type="primary"
          text="仅预订"
          @click="onSubmit(1)"
        />
        <van-goods-action-button
          type="info"
          text="预订并点菜"
          @click="onSubmit(2)"
        />
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Field,
  Button,
  GoodsAction,
  GoodsActionButton,
  Card,
  Tag,
  Icon,
  Dialog,
  Notify,
  Lazyload,
  Swipe,
  SwipeItem,
  ImagePreview,
} from "vant";
import restaurantApi from "@/api/restaurant.js";
// import formSelect from "@/components/form-select";
import { ls } from "@/utils/cache.js";
import { getRedirectFullUrl } from "@/api/auth.js";
import { mapState, mapActions } from "vuex";
// import { getSelectData } from "@/api/common.js";
import DateTimePicker from "@/components/date-time-picker/function";
import $config from "@/config/baseConfig";
import moment from "moment";
import { delUrlParam } from "@/utils/common";
import Vue from "vue";
Vue.use(Lazyload);
export default {
  name: "BookingIndex",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Notify.name]: Notify,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionButton.name]: GoodsActionButton,
    [Dialog.Component.name]: Dialog.Component,
    // formSelect
  },
  data() {
    return {
      info: {},
      form: {
        Contact: "",
        Phone: "",
        PersonCount: 1,
        CheckInTime: "",
      },
      salesmanData: [],
      images: [],
    };
  },
  computed: {
    ...mapState({
      wechatUserInfo: state => state.user.wechatUserInfo,
      companyCode: state => state.user.companyCode,
      restaruantInfo: state => state.user.restaruantInfo,
    }),
  },
  created() {
    ls.remove("order_data");
    ls.remove("order_table_info");
    const { restaruantInfo, wechatUserInfo } = this;
    if (this.companyCode) {
      this.getTableToken().then(() => {
        this.getRestaurantGallery();
      });
      if (
        !(
          wechatUserInfo &&
          wechatUserInfo.openid &&
          restaruantInfo &&
          restaruantInfo.CompanyCode == this.companyCode
        )
      ) {
        this.wechatLogin();
      }
    }
  },
  methods: {
    ...mapActions(["setWechatUserInfo", "setRestaruantInfo"]),
    preview() {
      ImagePreview({
        images: this.images,
      });
    },
    getRestaurantGallery() {
      this.images = [];
      restaurantApi.getRestaurantGallery().then(res => {
        if (res.Data && res.Data.length) {
          res.Data.forEach(el => {
            this.images.push($config.http.serverUrl + "/" + el);
          });
        }
      });
    },
    getTableToken() {
      return new Promise((resolve, reject) => {
        restaurantApi
          .getTableToken({ CompanyCode: this.companyCode })
          .then(res => {
            this.setRestaruantInfo({
              ...res.Data,
              CompanyCode: this.companyCode,
            });
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    wechatLogin() {
      const code = this.$route.query.code;
      this.loading = true;
      if (!code) {
        let url = window.location.href;
        getRedirectFullUrl({
          ReturnUrl: url,
          IsWechatPayConfig: true,
          companyCode: this.companyCode,
        }).then(res => {
          window.location.href = res.Data;
        });
      } else {
        restaurantApi
          .getWechatInfo({
            Code: code,
            CompanyCode: this.companyCode,
          })
          .then(res => {
            this.loading = false;
            this.setWechatUserInfo(res.Data);
          })
          .catch(() => {
            this.loading = false;
            const _this = this;
            _this.setWechatUserInfo({});
            Dialog.confirm({
              title: "微信登录失败，是否重新登录？",
            })
              .then(() => {
                const obj = delUrlParam("code");
                const pathName = window.location.pathname;
                //去掉code参数
                window.history.replaceState({}, "", pathName + obj.searchParam);
                location.reload();
              })
              .catch(() => {
                _this.$router.push({ name: "login" });
              });
          });
      }
    },
    handleChange(data) {
      if (data && data.Id) {
        this.form.SalesmanName = data.Text;
      } else {
        this.form.SalesmanName = "";
      }
    },
    showSelectDate() {
      const _this = this;
      const time = this.form.CheckInTime
        ? new Date(moment(this.form.CheckInTime))
        : "";
      DateTimePicker({
        value: time,
        type: "datetime",
        format: "YYYY-MM-DD HH:mm",
        change: date => {
          _this.form.CheckInTime = date;
        },
      });
    },
    onSubmit(type) {
      const { wechatUserInfo, form, $router } = this;
      if (
        !form.Contact ||
        !form.Phone ||
        !form.CheckInTime ||
        !form.PersonCount
      ) {
        Notify({ type: "danger", message: "带*号内容必填" });
        return false;
      }
      if (form.Phone && !/^1[3456789]\d{9}$/.test(form.Phone)) {
        Notify({ type: "danger", message: "电话号码格式错误" });
        return false;
      }
      if (type == 1) {
        //仅预订
        Dialog.confirm({
          title: "确定下单吗？",
        }).then(() => {
          let json = {
            ...form,
            NickName: wechatUserInfo.nickname,
            OpenId: wechatUserInfo.openid,
            IsConfirm: false,
          };
          restaurantApi.bookingOrder(json).then(() => {
            $router.push({
              name: "restaurantBookingList",
            });
          });
        });
      } else {
        ls.set("order_table_info", {
          ...form,
          NickName: wechatUserInfo.nickname,
          Contact: this.form.Contact,
        });
        this.$router.push({
          name: "restaurantOrderFood",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.booking-form/deep/.van-cell .van-field__label {
  width: 2.4rem;
}
.text-button-sm {
  font-size: 12px;
  text-align: right;
}
.swipe-wrap {
  height: 210px;
  position: relative;
  background: #fafafa;
  overflow: hidden;
  &.no-pic::after {
    content: "暂无图片";
    font-style: normal;
    text-align: center;
    line-height: 210px;
    width: 100%;
    display: block;
    color: #dadada;
    font-size: 16px;
    position: absolute;
    top: 0;
    left: 0;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>
